export const SESSION_START = 'session_start';
export const SESSION_START_SUBMITTED = 'session_start_submitted';
export const ONBOARDING_START = 'onboarding_start';
export const MAP_PAGE_SHOWN = 'map_page_show';
export const ENTER_EMAIL_SHOWN = 'email_page_show';
export const ENTER_EMAIL_SUBMITTED = 'email_page_completed';
export const SIGNUP_SUCCESS = 'account_created';
export const LEAD = 'lead';
export const PLAN_CHOSEN = 'paywall_page_completed';
export const CHECKOUT_SHOWN = 'subs_purchase_show';
export const CHECKOUT_SCREEN_LOAD = 'checkout_screen_load';
export const CARD_BRAND_CHOSEN = 'card_checkout_chosen';
export const BUY_SUBSCRIPTION_TAPPED = 'subs_purchase_started';
export const PROCESSING_STARTED = 'processing_started';
export const PAYMENT_ANIMATION = 'payment_animation_screen';
export const SUBSCRIBED = 'subs_purchase_completed';
export const UPSELL_SUBSCRIBED = 'upsell_purchase_completed';
export const PAYMENT_DECLINE = 'subs_purchase_failed';
export const DECLINE_TRY_AGAIN = 'payment_declined_try_again';
export const SUCCESS_PAGE_SHOWN = 'success_page_show';
export const TERMS_TAP = 'terms_of_use_tap';
export const POLICY_TAP = 'privacy_policy_tap';
export const POPUP_EVENT = 'payment_successful_popup';
export const INAPP_POPUP_EVENT = 'inapp_payment_successful_popup';
export const EMAIL_CONSENT_YES = 'email_consent_yes';
export const EMAIL_CONSENT_NO = 'email_consent_no';
export const GTM_LOAD_TIMEOUT = 'gtm_load_timeout';
export const GTM_NOT_CONFIGURED = 'gtm_not_configured';

export const LOAD = 'load';
export const CLICK = 'click';
export const SL = 'screen__load';
export const BC = 'button__continue';
export const BS = 'button__scroll';
export const LR = 'link__redirect';
export const OR = 'option__redirect';
export const OS = 'option__select';
